import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-69707f99")

_pushScopeId("data-v-69707f99")
const _hoisted_1 = { class: "container-homefeed" }
const _hoisted_2 = { class: "create-verify" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_EventResult = _resolveComponent("EventResult")
  const _component_Loader = _resolveComponent("Loader")
  const _component_ErrorResult = _resolveComponent("ErrorResult")
  const _component_TheAlert = _resolveComponent("TheAlert")
  const _component_ThePromoEvent = _resolveComponent("ThePromoEvent")
  const _component_TheFaqHome = _resolveComponent("TheFaqHome")
  const _component_TheImage = _resolveComponent("TheImage")
  const _component_TheFile = _resolveComponent("TheFile")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", null, _toDisplayString(_ctx.mainTitle), 1),
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createBlock("span", {
          key: tab,
          onClick: ($event: any) => (_ctx.activeTab = tab.order),
          class: { active : _ctx.activeTab === tab.order }
        }, _toDisplayString(tab.name), 11, ["onClick"]))
      }), 128))
    ]),
    _createVNode(_component_EventResult, {
      title: _ctx.eventTitle,
      description: _ctx.eventDescription,
      onResetEvent: _ctx.resetEvent
    }, null, 8, ["title", "description", "onResetEvent"]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_ErrorResult, {
      loading: _ctx.loading,
      error: _ctx.error,
      description: _ctx.errorMsg,
      onResetEvent: _ctx.resetEvent
    }, null, 8, ["loading", "error", "description", "onResetEvent"]),
    (_ctx.activeTab === 1)
      ? (_openBlock(), _createBlock(_component_TheAlert, {
          key: 1,
          onSetLoading: _ctx.setLoading,
          onInvokeError: _ctx.invokeError,
          onInvokeSuccess: _ctx.invokeSuccess
        }, null, 8, ["onSetLoading", "onInvokeError", "onInvokeSuccess"]))
      : _createCommentVNode("", true),
    (_ctx.activeTab === 2)
      ? (_openBlock(), _createBlock(_component_ThePromoEvent, {
          key: 2,
          onSetLoading: _ctx.setLoading,
          onInvokeError: _ctx.invokeError,
          onInvokeSuccess: _ctx.invokeSuccess
        }, null, 8, ["onSetLoading", "onInvokeError", "onInvokeSuccess"]))
      : _createCommentVNode("", true),
    (_ctx.activeTab === 3)
      ? (_openBlock(), _createBlock(_component_TheFaqHome, {
          key: 3,
          onSetLoading: _ctx.setLoading,
          onInvokeError: _ctx.invokeError,
          onInvokeSuccess: _ctx.invokeSuccess
        }, null, 8, ["onSetLoading", "onInvokeError", "onInvokeSuccess"]))
      : _createCommentVNode("", true),
    (_ctx.activeTab === 4)
      ? (_openBlock(), _createBlock(_component_TheImage, {
          key: 4,
          onSetLoading: _ctx.setLoading,
          onInvokeError: _ctx.invokeError,
          onInvokeSuccess: _ctx.invokeSuccess
        }, null, 8, ["onSetLoading", "onInvokeError", "onInvokeSuccess"]))
      : _createCommentVNode("", true),
    (_ctx.activeTab === 5)
      ? (_openBlock(), _createBlock(_component_TheFile, {
          key: 5,
          onSetLoading: _ctx.setLoading,
          onInvokeError: _ctx.invokeError,
          onInvokeSuccess: _ctx.invokeSuccess
        }, null, 8, ["onSetLoading", "onInvokeError", "onInvokeSuccess"]))
      : _createCommentVNode("", true)
  ]))
})